import { ConversionsNodeEditorHeader } from 'modules/workflows/components/NodeEditor/NodeEditorHeader';

import { BaseSendEditorProps } from '../BaseSendEditor.types';
import SectionTitle from '../SectionTitle';
import MultipleConversionSelection from './MultipleConversionSelection';

export interface ConversionSectionProps {
  /** The title shown in section header */
  title?: string;
  banner?: BaseSendEditorProps['conversionsBanner'];
  isDisabled?: boolean;
}

export const ConversionSection = ({
  title = 'Conversion',
  banner,
  isDisabled = false,
}: ConversionSectionProps) => {
  return (
    <>
      <SectionTitle title={title} banner={banner} HeaderCmp={ConversionsNodeEditorHeader} />
      <MultipleConversionSelection isDisabled={isDisabled} />
    </>
  );
};

export default ConversionSection;
